import { render, staticRenderFns } from "./DocumentMoveDialogTreeItem.vue?vue&type=template&id=296d92ed"
import script from "./DocumentMoveDialogTreeItem.vue?vue&type=script&lang=js"
export * from "./DocumentMoveDialogTreeItem.vue?vue&type=script&lang=js"
import style0 from "./DocumentMoveDialogTreeItem.vue?vue&type=style&index=0&id=296d92ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports